import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { LoadingService } from './loading.service';
import { finalize } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageRouterService {

  constructor(
    private router: Router,
    private httpService: HttpService,
    private loading: LoadingService
  ) {}

  /**
   * Evalúa el tipo de página y navega al destino correcto
   */
  async navigateToPage(pageId: string | number) {
    if (!pageId) {
      console.error('PageRouterService: No se proporcionó pageId');
      return;
    }

    console.log('PageRouterService: Evaluando página', pageId);

    // Mostrar loading mientras se evalúa la página
    await this.loading.show();

    this.httpService.myGet(`${Environment.API_BASE_URL_V2}/api/empatica/v1/pages/${pageId.toString()}`)
      .pipe(finalize(async () => await this.loading.hide()))
      .subscribe({
        next: (response) => {
          console.log('PageRouterService: Configuración de página cargada:', response);
          
          if (response && (response.is_chatbot || response.isChatbot)) {
            // Es una página de chatbot
            console.log('PageRouterService: Navegando al chatbot');
            this.router.navigate(['/chatbot'], {
              queryParams: { pageId: pageId.toString() }
            });
          } else {
            // Es una página genérica
            console.log('PageRouterService: Navegando a página genérica');
            this.router.navigate([`/generic/${pageId}`]);
          }
        },
        error: (error) => {
          console.error('PageRouterService: Error evaluando página:', error);
          // En caso de error, navegar a página genérica como fallback
          this.loading.hide().then(() => {
            this.router.navigate([`/generic/${pageId}`]);
          });
        }
      });
  }

  /**
   * Navega directamente a una página genérica (para casos donde ya sabemos el tipo)
   */
  navigateToGenericPage(pageId: string | number) {
    if (!pageId) {
      console.error('PageRouterService: No se proporcionó pageId');
      return;
    }

    console.log('PageRouterService: Navegando directamente a página genérica:', pageId);
    this.router.navigate([`/generic/${pageId}`]);
  }

  /**
   * Carga una página genérica directamente (sin evaluación previa)
   */
  loadGenericPage(pageId: string | number) {
    if (!pageId) {
      console.error('PageRouterService: No se proporcionó pageId');
      return;
    }

    console.log('PageRouterService: Cargando página genérica directamente:', pageId);
    this.router.navigate([`/generic/${pageId}`]);
  }
}
